type Join<K, P> = K extends string | number
  ? P extends string | number
    ? `${K}.${P}`
    : never
  : never;

type Prev = [never, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export type Paths<T, D extends number = 10> = [D] extends [never]
  ? never
  : T extends object
  ? {
      [K in keyof T]: K extends string | number
        ? T[K] extends object
          ? Join<K, Paths<T[K], Prev[D]>>
          : K
        : never;
    }[keyof T]
  : never;
export type PathsToStrings<T, Prefix extends string | ''> = T extends object
  ? {
      [K in keyof T & string]: T[K] extends string
        ? `${Prefix}${K}`
        : T[K] extends object
        ? `${Prefix}${K}.` | PathsToStrings<T[K], `${Prefix}${K}.`>
        : never;
    }[keyof T & string]
  : '';
export type ValueOf<T> = T[keyof T];
export type VariablesMap = { [key: string]: string | number };
export type PathsValue<T extends Array<string>> = ValueOf<{
  [K in keyof T]: T[K];
}>;

export type PathsTrValue<T> = ValueOf<{
  [K in keyof T]: T[K];
}>;

export function replaceVariable(text: string, variables: VariablesMap): string {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in variables) {
    if (Object.hasOwn(variables, key)) {
      const regex = new RegExp(`{{${key}}}`, 'g');
      // eslint-disable-next-line no-param-reassign
      text = text.replace(regex, String(variables[key]));
    }
  }
  return text;
}
export function getPathsToStrings<T extends object>(
  obj: T,
): PathsToStrings<T, ''>[] {
  const paths: PathsToStrings<T, ''>[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-shadow
  function traverse(obj: any, prefix: string) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        paths?.push(`${prefix}${key}` as PathsToStrings<T, ''>);
      } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        traverse(obj[key], `${prefix}${key}.`);
      }
    }
  }
  traverse(obj, '');
  return paths as PathsToStrings<T, ''>[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getValueFromPath<T extends Record<string, any>>(
  obj: T,
  path: string,
): string {
  const keys = path.split('.');
  let value = obj;

  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return ''; // Se não encontrar a chave ou se o valor não for um objeto, retorna undefined
    }
  }

  return value as never as string;
}
